import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import UnderConstruction from "@/components/UnderConstruction";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined); // undefined=loading, null=notFound
  useEffect(() => {
    api.get(`/pages/by-slug/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(null));
  }, [slug]);

  if (page === undefined) return <div className="py-32 text-center">Carregando…</div>;
  if (page === null || page?.status === "under_construction" || page?.status === "hidden") {
    return <UnderConstruction title={page?.title || "Página em construção"} />;
  }
  return (
    <div>
      <section className="py-20 bg-[color:var(--marupiara-obsidian)] text-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h1 className="font-serif text-5xl sm:text-6xl">{page.title}</h1>
        </div>
      </section>
      <section className="py-16 bg-[color:var(--marupiara-ivory)]">
        <div className="max-w-3xl mx-auto px-6 prose-editorial text-neutral-800" dangerouslySetInnerHTML={{ __html: page.content }} />
      </section>
    </div>
  );
}
